import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";

import {
  getOrgProfileByName,
  getOrgProfilesByParentId,
} from "@/actions/org-profiles";
import type { OrgProfileModel } from "@/api";
import { isValidOrgId } from "@/lib/utils";

export const useWorkAccessLevels = () => {
  const { orgId } = useParams();

  const { data: workAccessLevels, isLoading } = useQuery<OrgProfileModel[]>({
    queryKey: ["workAccessLevels", orgId],
    queryFn: async () => {
      const id = orgId as string;
      const workAccessLevelKey = await getOrgProfileByName(
        id,
        "Work Access Level",
      );
      if (workAccessLevelKey && workAccessLevelKey[0]?.id) {
        const workAccessLevelProfiles = await getOrgProfilesByParentId(
          id,
          workAccessLevelKey[0].id,
        );
        return workAccessLevelProfiles || [];
      }
      return [];
    },
    enabled: isValidOrgId(orgId as string | undefined),
  });

  return { workAccessLevels, isLoading };
};
